export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_10.4491caa8.jpg";